export default {
  redCardTitle: {
    background: 'red',
  },
  blueCardTitle: {
    background: 'blue',
  },
  greenCardTitle: {
    background: 'green',
  },
  summaryCharts: {
    flex: 1,
    flexDirection: 'row',
  },
  card: {
    margin: 10,
  },
  totalRow:{
    backgroundColor: 'lightgrey',
  },
  totalColumn: {
    backgroundColor: 'lightgrey',
    fontWeight: 'bold',
  },
  total: {
    fontWeight: 'bold',
  },
};



// WEBPACK FOOTER //
// ./src/components/Reports/ItemBreakdownReport/styles.js